module.exports = __webpack_public_path__ + "assets/account.d3990ffdff1b6cc7e5ee6bb829ecde2a.svg";